export const onChangeDashboardAction = (props: any) => {
	const { setValue } = props;
	// eslint-disable-next-line no-underscore-dangle
	const formValues = props?.control?._formValues;
	const segName: string = formValues?.segmentName;
	const doc = JSON.parse(formValues?.mapValue);
	setValue('expName', doc.segmentExp[segName]?.expName);
	const targetId = {
		segmentName: segName,
		bucketName: formValues?.bucketName
	};
	const result = doc?.segmentBucketRank
		? doc?.segmentBucketRank.find((item: any) => JSON.stringify(item._id) === JSON.stringify(targetId))
		: null;
	setValue('rank', result?.maxRank + 1 || 1);
};

export const onChangeOfferValueAction = (props: any) => {
	const { setValue, name } = props;
	const valueInString = document.getElementsByName(name)[0].value?.replace(/,/g, '');
	if (!Number.isNaN(valueInString)) {
		const value = Number(valueInString);
		setValue(name, value.toLocaleString('en-IN'));
	}
};
